import React from "react";
import { EmployeeSelector as BaseEmployeeSelector } from "./EmployeeSelector";
import { usePeopleContext } from "../contexts/PeopleContext";

interface Employee {
  id: number;
  name: string;
}

interface SmartEmployeeSelectorProps {
  value: number[];
  onChange: (employeeIds: number[]) => void;
  disabled?: boolean;
  error?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
  maxSelectedLabels?: number;
}

export const SmartEmployeeSelector: React.FC<SmartEmployeeSelectorProps> = (
  props
) => {
  const { people, loading } = usePeopleContext();

  // Transform people data to match Employee interface
  const employees: Employee[] = people.map((person) => ({
    id: person.id,
    name: `${person.name} ${person.surname}`,
  }));

  if (loading) {
    return (
      <BaseEmployeeSelector
        {...props}
        employees={[]}
        disabled={true}
        placeholder="Loading employees..."
      />
    );
  }

  return <BaseEmployeeSelector {...props} employees={employees} />;
};
